<template>
    <div class="col-md-12">
        <div class="box light-gray">
            <img src="/assets/img/svg/dashboard.svg" alt="">
            <span class="title" v-html="widget.name"></span>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['widget']        
    }
</script>

